import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from "react-router-dom"
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ToastProvider } from '@/app/providers'
import { ToastContainer } from '@/shared/components/common/ToastContainer'
import ErrorBoundary from '@/shared/components/common/ErrorBoundary'
import { router } from "@/app/router/Router"
import { appSettings } from '@/config'
import { initializeLogger } from '@/infra/logging'
import './index.css'

// Initialize the logger
initializeLogger({
  appName: appSettings.app.name,
  environment: appSettings.app.environment,
  isDevelopment: appSettings.app.isDevelopment,
  logLevel: appSettings.app.isDevelopment ? 'trace' : 'warn',
  apiBaseUrl: appSettings.api.baseUrl,
  logsEndpoint: appSettings.logging.logsEndpoint,
  remoteLoggingEnabled: appSettings.logging.enabled,
});

// Create query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: appSettings.api.retry.maxRetries,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <ErrorBoundary fallbackMessage="An error occurred while loading the page.">
          <Suspense>
            <RouterProvider router={router} />
          </Suspense>
        </ErrorBoundary>
        <ToastContainer />
        <ReactQueryDevtools initialIsOpen={false} />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
